export default __webpack_public_path__ + "static/media/icon-instagram-2.4f5d8243.svg";